import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

// Padrão do sistema (19/07/2026, revisado 02/09/2026): TODA página tem o botão FAQ,
// que abre a página de FAQ em NOVA ABA já filtrada pelos FAQs vinculados à
// funcionalidade da página de origem (functionalities.faq_list). A página de origem
// é lida da própria URL (?page=); sem vínculo, o FAQ abre completo.

interface FaqButtonProps {
  onClick?: () => void;
}

const FaqButton: React.FC<FaqButtonProps> = ({ onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    const currentPage = new URLSearchParams(window.location.search).get('page');
    const fromParam = currentPage && currentPage !== 'faq' ? `&from=${encodeURIComponent(currentPage)}` : '';
    window.open(`${window.location.origin}/?page=faq${fromParam}`, '_blank');
  };

  return (
    <Tooltip title="Perguntas frequentes desta página">
      <IconButton
        onClick={handleClick}
        aria-label="Perguntas frequentes"
        className="c4u-btn-icon c4u-btn-icon--help"
      >
        <HelpOutline />
      </IconButton>
    </Tooltip>
  );
};

export default FaqButton;
